const ldRouter = [
  // 5分钟办件
  {
    path: '/process',
    name: 'process',
    component: () => import('@/views/5min/index.vue')
  },
]
export default ldRouter